<template>
  <div class="register">
    <section class="head-wrapper">
      <header class="head">
        <a class="logo-wrapper" href="/">
          <img src="./logo.jpg" alt="logo" width="180" height="40">
        </a>
        <p class="text-wrapper">已有账号？
          <router-link class="gotoLog" to="/log">返回登录></router-link>
        </p>
      </header>
    </section>

    <div class="content">
      <section class="block student" @click="goto('student')">
        <img src="./student_chose.png" alt="学生注册" width="500" height="632">
      </section>
      <section class="block teacher" @click="goto('teacher')">
        <img src="./teacher_chose.png" alt="老师注册" width="500" height="632">
      </section>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  export default{
    methods: {
      goto(url){
        this.$router.push('/register-' + url);
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .register
    height: 100%
    background: #ffffff url('./background.png') no-repeat center / cover
    .head-wrapper
      width: 100%
      background: #fff
      .head
        width: 1226px
        height: 80px
        margin: 0 auto
        background: #fff
        font-size: 0
        .logo-wrapper
          float: left;
          height: 43px;
          width: 192px;
          padding-top: 18px;
        .text-wrapper
          float: right
          height: 80px
          line-height: 80px
          font-size: 14px
          color: #333
          text-align: center
          .gotoLog
            color: #ff6700
    .content
      margin: 40px auto 0
      font-size: 0
      width: 1226px
      .block
        float: left
        width: 500px
        margin-right: 20px
        cursor: pointer
        &.student
          margin-left: 103px;
        &:teacher
          margin: 0

</style>



// WEBPACK FOOTER //
// src/page/register/Register.vue